<template>
    <div class="main-logo">

        <router-link to="/" class="logo">
            <img class="main-logo-desktop" 
                 :src="desktopLogoImage"
                 alt="logo"/>
            <img class="main-logo-mobile" 
                 :src="mobileLogoImage"
                 alt="logo"/>
        </router-link>

    </div>
</template>

<script>
import Vue from 'vue'
import {store} from '@/apps/default/store'
import Theme from '@/providers/Theme'

export default Vue.extend({
    name: "MainLogo",
    computed: {
        desktopLogoImage() {
            return Theme.getDesktopLogoImage()
        },
        mobileLogoImage() {
            return Theme.getMobileLogoImage()
        }
    }
})
</script>

<style lang="scss">
@import '../../sass/variables_mixins';

.main-logo {
    display: block;
    @include vertical-center;
    left: 0;
    @include transition(opacity .3s);
    z-index: 10;

    .main-logo-desktop {
        height: 24px;
        @media (min-width: 1200px) {
            height: 32px;
        }
    }

    &:hover {
        opacity: .5;
    }
}

// on mobile, hide main logo and display crumbs in its place
@media (max-width: 991px) {
    .main-logo-mobile {
        display: block;
        width: 32px;
    }
    .main-logo-desktop {
        display: none;
    }
}

@media (min-width: 992px) {
    .main-logo-mobile {
        display: none;
    }
    .main-logo-desktop {
        display: block;
    }
}

</style>
